import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo3_Carlos } from '../../../../../utils/EN/Modals/directors';

const ModalVideoCarlos3 = () => {
  return (
    <>
      <ModalVideo
        id="carlos-video-3"
        dataText={TextVideo3_Carlos}
        videoSrc="https://player.vimeo.com/video/395269889?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_CARLOS_3"
      />
    </>
  );
};

export default ModalVideoCarlos3;
